import React, { useCallback, useContext, useState, useEffect } from "react";
import { isNil } from "lodash";
import "./createMediaRequest.scss";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Divider,
  List,
  ListItem,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  CREATE_MEDIA,
  TEXT_USAGE_TYPE,
  NAMESPACE_TO_ID_TYPE_MAPPING,
} from "../../../constants/CreateMediaRequest";
import { MediaRequestContext } from "../../../context/MediaRequestContext";
import { ConfigContext } from "../../../security/ConfigContext";
import { getEditRate } from "./util";

const Subtitles = ({ manifestation, assetTitle, entityType, idType }) => {
  const [expanded, setExpanded] = useState(false);
  const {
    videoContainerId,
    selectedFiles,
    _setSelectedFiles,
    handleSelectFile,
    _setIdAccordionExpanded,
    validAssets,
    idAccordionExpanded,
    titleAccordionExpanded,
    _setTitleAccordionExpanded,
    transferRegion,
    renamedFilename,
    getAssetType,
    getSourceId,
    getSourceIdNamespace,
  } = useContext(MediaRequestContext);
  const config = useContext(ConfigContext);
  const editRate = getEditRate(manifestation.editRate);
  const { environment } = config[0].app;
  let totalSubtitlesAvailable = 0;

  manifestation?.containers?.forEach((container) => {
    manifestation?.components?.forEach((component) => {
      if (
        component.componentType?.includes("timed-text") &&
        component.trackReference?.containerId === container.containerId  &&
        !videoContainerId[container.containerId]
      ) {
        totalSubtitlesAvailable += 1;
      }
    });
  });

  const handleSelectAllFile = (e) => {
    let selectedFileDetails = { ...selectedFiles };
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.components?.forEach((component) => {
          const subtitle =
            component.componentType?.includes("timed-text") &&
            component.trackReference?.containerId === container.containerId &&
            !videoContainerId[container?.containerId];
          if (subtitle) {
            if (e.target.checked) {
              if (file in selectedFileDetails) {
                selectedFileDetails[file]["isChecked"] = true;
                if (transferRegion[manifestation?.id] === "GCSSNY-MX_Content App") {
                  selectedFileDetails[file]["sourceUri"] = container.path;
                  selectedFileDetails[file]["containerId"] = container.containerId;
                }
              }
              else {
                const alternateId = getSourceId(manifestation);
                const idNamespace = getSourceIdNamespace(manifestation);
                const manifestationId = manifestation?.id;
                const assetType = getAssetType(entityType);
                selectedFileDetails = {
                  ...selectedFileDetails,
                  [file]: {
                    id: alternateId,
                    namespace: idNamespace,
                    idType: NAMESPACE_TO_ID_TYPE_MAPPING[idNamespace],
                    fileType: "Subtitle",
                    title: assetTitle,
                    transfer: transferRegion[manifestationId],
                    renamePrefix: !isNil(assetType) ? `${assetTitle.replace(/\s+/g, '')}_${assetType}_${editRate}`: `${assetTitle.replace(/\s+/g, '')}_${editRate}`,
                    renamedFilename: renamedFilename[file],
                    ...(transferRegion[manifestationId] === "GCSSNY-MX_Content App" && {
                      sourceUri: container.path,
                      containerId: container.containerId,
                    }),
                    isChecked: true,
                    isMamProxy: false,
                  },
                };
              }
            } else {
              selectedFileDetails[file]["isChecked"] = false;
            }
            _setSelectedFiles(selectedFileDetails);
          }
        });
      }
    });
  };

  const areAllCheckboxesChecked = useCallback(() => {
    let existingSubtitles = {};
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.components?.forEach((component) => {
          const subtitle =
            component.componentType?.includes("timed-text") &&
            component.trackReference?.containerId === container.containerId  &&
            !videoContainerId[container?.containerId];
          if (subtitle) {
            existingSubtitles[file] = true;
          }
        });
      }
    });
    for (const fileName in existingSubtitles) {
      if (!selectedFiles[fileName]?.isChecked) {
        return false;
      }
    }
    return true;
  }, [manifestation.components, manifestation.containers, selectedFiles, videoContainerId]);

  const isDisabled = useCallback(() => {
    for (const container of manifestation.containers) {
      for (const component of manifestation.components) {
        const subtitle =
          component.componentType?.includes("timed-text") &&
          component.trackReference?.containerId === container.containerId  &&
            !videoContainerId[container?.containerId];
          if (subtitle) {
            if (environment === "uat" && !container["path"].includes(environment)) {
              if (!container["path"].includes("sit")) {
                return true;
              }
            } else {
              if (!container["path"].includes(environment)) {
                return true;
              }
            }
          }
      }
    }
    return false;
  }, [manifestation.components, manifestation.containers, environment, videoContainerId]);

  const isPathInvalid = (path) => {
    if (environment === "uat" && !path.includes(environment)) {
      if (!path.includes("sit")) {
        return true;
      }
    } else {
      if (!path.includes(environment)) {
        return true;
      }
    }
    return false;
  };

  const handleChange = (file) => (e) => {
    handleSelectFile(e, file, "Subtitle", manifestation, assetTitle, editRate, entityType, idType);
  };
  
  const getSubtitlesAccordionDetails = (components, containers) =>
    containers?.map((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        return (
          <>
            {components?.map(
              (component) =>
                component.componentType?.includes("timed-text") &&
                component.trackReference?.containerId ===
                  container.containerId  &&
                  !videoContainerId[container?.containerId] && (
                  <>
                    <Divider />
                    <div className="mt-10" key={`subtitles-container-${file}`}>
                      <span>
                        <Checkbox
                          className="pt-6"
                          onChange={handleChange(file)}
                          checked={selectedFiles[file]?.isChecked || false}
                          disabled={isPathInvalid(container["path"])}
                        />
                      </span>
                      <span className="font-bold word-break-all">{renamedFilename[file]}</span>
                    </div>
                    <Divider />
                    <div className={(idType === "dmi" || idType === "cantemo" || idType === "bim") ? "mt-10 mb-10" : "mt-10"} key={`subtitles-path-${file}`}>
                      <span className="font-bold">{CREATE_MEDIA.pathLabel}</span>
                      <span className="word-break-all">{container.path}</span>
                    </div>
                    {(idType === "dmi" || idType === "cantemo" || idType === "bim") ? null : (
                      <List
                        className="media-desc-list"
                        key={`subtitles-description-${file}`}
                      >
                        {getSubtitleDetails(component)}
                      </List>
                    )}
                  </>
                )
            )}
          </>
        );
      }
      return null;
    });

  const getSubtitleDetails = (component) => {
    const textUsageType = TEXT_USAGE_TYPE[component.textUsageType] || "Unknown";
    const language = component.writtenLanguage || "Unknown";
    const subtitleDescription = `Subtitle (${textUsageType}, ${language})`;
    return (
      <ListItem
        className="media-desc-list-item"
        key={`subtitle-description-${language}-${textUsageType}}`}
      >
        {subtitleDescription}
      </ListItem>
    );
  };

  const getExpandedAccordionInfo = () => {
    const idAccStructure = { ...idAccordionExpanded };
    const titleAccStructure = { ...titleAccordionExpanded };
    Object.keys(validAssets).forEach((validAssetsKey) => {
      idAccStructure[validAssetsKey] = true;
      titleAccStructure[validAssetsKey] = true;
    });
    _setTitleAccordionExpanded(titleAccStructure);
    _setIdAccordionExpanded(idAccStructure);
  };

  useEffect(() => {
    manifestation.containers?.forEach((container) => {
      if (container.path) {
        const pathSplit = container.path?.split(".");
        const format = pathSplit[pathSplit.length - 1];
        const file = `${container.containerId}.${format}`;
        manifestation.components?.forEach((component) => {
          const subtitle =
            component.componentType?.includes("timed-text") &&
            component.trackReference?.containerId === container.containerId  &&
            !videoContainerId[container?.containerId];
          if (subtitle && file in selectedFiles && selectedFiles[file]["isChecked"]) {
            getExpandedAccordionInfo();
            setExpanded(true);
          }
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manifestation.components, manifestation.containers]);

  return (
    <>
      {totalSubtitlesAvailable === 0 && null}
      {totalSubtitlesAvailable > 0 && (
        <Accordion
          classes={{
            expanded: "media-accordion",
          }}
          className="media-assets-accordion"
          variant="outlined"
          expanded={expanded}
          onChange={(e, expanded) => {
            setExpanded(expanded);
          }}
        >
          <AccordionSummary
            className="media-asset-container-accordion-summary"
            expandIcon={<ExpandMoreIcon />}
            IconButtonProps={{ style: { color: "white" } }}
          >
            {CREATE_MEDIA.subtitlesLabel}
          </AccordionSummary>
          <AccordionDetails className="media-asset-accordion-details">
            <div>
              <span>
                <Checkbox
                  className="pt-6"
                  onChange={(e) => handleSelectAllFile(e)}
                  checked={areAllCheckboxesChecked() || false}
                  disabled={isDisabled() || false}
                />
              </span>
              <span>{CREATE_MEDIA.selectAllSubtitlesLabel}</span>
            </div>
            {getSubtitlesAccordionDetails(
              manifestation?.components,
              manifestation?.containers
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

Subtitles.defaultProps = {
  manifestation: {},
  assetTitle: "",
  entityType: "",
  idType: null,
};

export default Subtitles;
